import React from 'react';
import {
  string,
  func
} from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components/dist/index';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useConfigService, useStore } from '@thd-nucleus/experience-context';
import { DEFAULT_CALC_CLASSES, DEFAULT_DESCRIPTION } from '../../../constants';
import { getPIPCalculatorProps, shouldDisplayPipCalculator } from '../../../helpers/pipCalculatorHelper';
import { CalculateByDimensions } from '../../CalculateByDimensions';
import { CalculatorFooter } from '../../CalculatorFooter';
import { CalculatorHeader } from '../../CalculateHeader';
import { CalculatorInputSections } from '../../CalculatorInputSections';
import { CalculatorProvider } from '../CalculatorProvider';
import { Results } from './Results/Results';
import { pipCalculatorDataModel } from '../../dataModel';

export const PIPCalculator = ({ itemId, onCalculate }) => {
  const estimatorEnabled = useConfigService('fs:estimatorEnabled');
  const { storeId } = useStore();

  const { data } = useDataModel('clientOnlyProduct', {
    skip: !itemId,
    ssr: false,
    variables: {
      itemId,
      storeId
    }
  });

  if (estimatorEnabled) {
    return null;
  }

  // todo: see if these empty bracket fallbacks are necessary
  const { product = {} } = data || {};
  const {
    fulfillment = {},
    info = {},
    installServices = {},
    pricing = {},
    taxonomy = {}
  } = product;

  if (!shouldDisplayPipCalculator({ fulfillment, info, installServices })) {
    return null;
  }

  const pipCalculatorProps = getPIPCalculatorProps({ info });
  const { calcProps, resultsProps } = pipCalculatorProps;

  return (
    <div data-component="PIPCalculator">
      <CalculatorProvider
        allowAdditionalCoverage
        calculatorType={calcProps.calculatorType}
        lineItemName={calcProps.lineItemName}
        onCalculate={onCalculate}
        unitsPerCase={resultsProps.unitsPerCase}
        taxonomy={taxonomy}
      >
        <div className={DEFAULT_CALC_CLASSES}>
          <CalculatorHeader />
          <Typography>{DEFAULT_DESCRIPTION}</Typography>
          <CalculateByDimensions dimensionNames={calcProps.dimensionNames} />
          <CalculatorInputSections dimensionNames={calcProps.dimensionNames} />
          <CalculatorFooter />
        </div>
        <Results
          caseUnitOfMeasure={resultsProps.caseUnitOfMeasure}
          pricing={pricing}
          unitsPerCase={resultsProps.unitsPerCase}
          uom={resultsProps.uom}
        />
      </CalculatorProvider>
    </div>
  );
};

PIPCalculator.displayName = 'PIPCalculator';

PIPCalculator.dataModel = pipCalculatorDataModel;

PIPCalculator.propTypes = {
  itemId: string.isRequired,
  onCalculate: func.isRequired
};